import React from 'react';
import Radium from 'radium';

const checkBoxDim = 25 + "px";

const CheckBocks = ({isChecked}) => {

  const cbStyles = {
    backgroundColor: "#333",
    width: checkBoxDim,
    height: checkBoxDim,
    borderRadius: "3px",
    display: "inline-block",
    color: "white",
  }

  const cbContent = {
    position: "absolute",
    width: checkBoxDim,
    height: checkBoxDim,
    textAlign: "center",
    lineHeight: checkBoxDim,
  }

  return (
    <div style={cbStyles}><div style={cbContent}>{isChecked ? 'X' : ''}</div></div>
  )
}

export default Radium(CheckBocks);



// WEBPACK FOOTER //
// ./src/components/CheckBocks.js